import React, { useState } from "react";
import BackHeader from "@components/header/BackHeader";
import TitleNavigateButton from "@components/button/TitleNavigateButton";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import BasicModal from "@components/modal/BasicModal";
import useAuth from "@hook/useAuth";
import { ModalContent } from "@components/modal/ModalContent";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import { Flex } from "antd";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4rem",
  padding: "4rem 2rem",
});

const AccountManagement = () => {
  const theme = useTheme();
  const [logoutModal, setLogoutModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);

  const navigate = useNavigate();
  const { logout } = useAuth();
  const { patchDeactivate } = useApiRequest();

  const handleOpenModal = () => {
    setLogoutModal(true);
  };

  const handleLogout = () => {
    logout();
  };

  const handlePasswordModal = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "GOOGLE" || loginType === "APPLE") {
      setIsModalOpen(true);
    } else {
      navigate("/change-password");
    }
  };

  // 탈퇴하기
  const { mutate } = useMutation({
    mutationFn: () => patchDeactivate(),
    onSuccess: () => {
      setDeactivateModal(false);
      localStorage.removeItem("apple_first_name");
      localStorage.removeItem("apple_last_name");
      localStorage.removeItem("apple_email");
      localStorage.setItem("isAutoLogin", "false");

      navigate("/");
      logout();
    },
  });

  return (
    <>
      <BackHeader title={"계정관리"} />

      <Container>
        <TitleNavigateButton
          title="비밀번호 변경하기"
          route="/change-password"
          onClick={handlePasswordModal}
        />

        <TitleNavigateButton title="로그아웃" onClick={handleOpenModal} />

        <TitleNavigateButton
          title="탈퇴하기"
          route="/"
          color={theme.color.orange}
          onClick={() => setDeactivateModal(true)}
        />
      </Container>

      <BasicModal
        open={logoutModal}
        setOpen={setLogoutModal}
        activeName="로그아웃"
        closeName="취소"
        activeEvent={handleLogout}>
        <ModalContent mainMessage="로그아웃 하시겠습니까?" />
      </BasicModal>

      <BasicModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        activeEvent={() => {
          setIsModalOpen(false);
        }}
        activeName="확인"
        notice>
        <ModalContent mainMessage="SNS 회원은 비밀번호 변경이 불가합니다." />
      </BasicModal>

      <BasicModal
        open={deactivateModal}
        setOpen={setDeactivateModal}
        activeName="탈퇴하기"
        closeName="취소"
        warning
        activeEvent={() => {
          mutate();
        }}>
        <Flex vertical gap={"1rem"} justify="column" align="center">
          <span>{"탈퇴하시겠습니까?"}</span>
          <span>{"탈퇴한 계정의 활성화를 원할 경우"}</span>
          <Flex gap={"0.4rem"}>
            <span>{"고객센터에 문의해주시길 바랍니다."}</span>

            <span style={{ fontWeight: "bold" }}>{"바랍니다."}</span>
          </Flex>
        </Flex>
      </BasicModal>
    </>
  );
};

export default AccountManagement;
